import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useDocumentCache } from 'entities/document/api/hooks/use-document-cache';
import { handleBatchTask } from 'shared/api/batches';
import { postDocumentsDuplicate } from '../requests';
import type { PostDocumentDuplicateRequestType } from '../types';

export const usePostDocumentDuplicate = () => {
  const queryClient = useQueryClient();
  const { refetchAllDocumentsQueries } = useDocumentCache();

  const onSuccess = () => {
    const queries = queryClient.getQueriesData({});

    // refetch all documents queries
    queries.forEach((query: any) => {
      if (query[0][0] === API_QUERY_KEYS.documents) {
        queryClient.refetchQueries(query[0]);
      }
    });
    refetchAllDocumentsQueries();
  };

  return useMutation({
    mutationFn: (data: PostDocumentDuplicateRequestType) =>
      handleBatchTask(postDocumentsDuplicate(data)),
    onSuccess,
  });
};
